var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/document-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 2.66732C4.29783 2.66732 3.99935 2.96579 3.99935 3.33398V10.6673C3.99935 11.0355 3.70087 11.334 3.33268 11.334C2.96449 11.334 2.66602 11.0355 2.66602 10.6673V3.33398C2.66602 2.22941 3.56145 1.33398 4.66602 1.33398H8.38987C8.74349 1.33398 9.08263 1.47446 9.33268 1.72451L12.9422 5.33398C13.1922 5.58403 13.3327 5.92317 13.3327 6.27679V12.6673C13.3327 13.7719 12.4373 14.6673 11.3327 14.6673H6.66602C6.29783 14.6673 5.99935 14.3688 5.99935 14.0007C5.99935 13.6325 6.29783 13.334 6.66602 13.334H11.3327C11.7009 13.334 11.9993 13.0355 11.9993 12.6673V6.27679L8.38987 2.66732H4.66602ZM7.99935 8.00065C7.26297 8.00065 6.66602 8.5976 6.66602 9.33398C6.66602 9.70236 6.81452 10.0348 7.05654 10.2768C7.29856 10.5188 7.63097 10.6673 7.99935 10.6673C8.73573 10.6673 9.33268 10.0704 9.33268 9.33398C9.33268 8.5976 8.73573 8.00065 7.99935 8.00065ZM5.33268 9.33398C5.33268 7.86123 6.52659 6.66732 7.99935 6.66732C9.47211 6.66732 10.666 7.86123 10.666 9.33398C10.666 10.8067 9.47211 12.0007 7.99935 12.0007C7.50509 12.0007 7.04176 11.8658 6.6448 11.6313L3.80409 14.4721C3.54374 14.7324 3.12163 14.7324 2.86128 14.4721C2.60093 14.2117 2.60093 13.7896 2.86128 13.5292L5.70199 10.6885C5.46754 10.2916 5.33268 9.82824 5.33268 9.33398Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/document-search.494567feb5b1caae7c99afb30e3a38a8.svg";
export { ForwardRef as ReactComponent };